var groupType = {
    treeView: 'treeView',
    checkbox: 'checkbox',
    radio: 'radio',
    button: 'button',
    plain: 'plain',
};
export default groupType;
//# sourceMappingURL=groupType.js.map